import { render } from "./WagerRewardsDialog.vue?vue&type=template&id=0de50a60"
import script from "./WagerRewardsDialog.vue?vue&type=script&lang=js"
export * from "./WagerRewardsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__